import React from 'react';

import Loading from '../../../Common/Loading';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import './styles/Charts.css';
import { OcurrenceByLocalAndGender } from './OcurrenceListByLocalAndGender';
import { OcurrencesByGenderAnually } from './OcurrencesByGenderAnually';
import { OcurrencesByGenderMonthly } from './OcurrencesByGenderMonthly';

const Profile = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <OcurrenceByLocalAndGender />
            <div className="charts-side-by-side-dashboards">
                <OcurrencesByGenderAnually />
                <OcurrencesByGenderMonthly />
            </div>
        </>
    );
};

export default Profile;
